import React from 'react';

const HeroSection = () => {
  const userLang = navigator.language || navigator.userLanguage;

  return (
    <div className="relative w-full min-h-screen overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: "url(https://res.cloudinary.com/sheyou/image/upload/v1727638013/exchange_8ed19f8200.svg)" }}
      />
      
      {/* Content Container with Circular Gradient Background */}
      <div className="relative w-full min-h-screen flex items-center justify-center">
        {/* This is the circular gradient background */}
        <div 
          className="absolute  rounded-full" 
          style={{
            width:'600px',
            height:'600px',
            background: 'radial-gradient(circle, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.6) 20%, rgba(255,255,255,0.5) 40%, rgba(255,255,255,0.2) 70%, transparent 100%)',
            boxShadow: '0 0 100px 50px rgba(255,255,255,0.2)'
          }}
        />
        
        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-8 py-12 text-center">
          {/* Main Title Section */}
          <div className="mb-8 sm:mb-12">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-4 sm:mb-6 leading-tight text-gray-900">
              {userLang === 'zh-CN' ? '发现，穿搭，分享' : 'Discover, Wear, Share'}
            </h1>
          </div>

          {/* CTA Button */}
          <a 
            href="/browse"
            className="inline-flex items-center px-6 hover:text-white sm:px-8 py-3 sm:py-4 text-base sm:text-lg font-semibold rounded-md bg-brand-orange text-white hover:bg-brand-orange-dark transition duration-300 ease-in-out transform hover:scale-105"
          >
            {userLang === 'zh-CN' ? '开始探索' : 'Start Exploring'}
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeroSection; 